import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiUserGenderQueryResponse,
  GetApiUserGender401,
  GetApiUserGender403,
} from "../../../types/GetApiUserGender";

export function getGetApiUserGenderUrl() {
  return `/api/User/gender` as const;
}

/**
 * {@link /api/User/gender}
 */
export async function getApiUserGender(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiUserGenderQueryResponse,
    ResponseErrorConfig<GetApiUserGender401 | GetApiUserGender403>,
    unknown
  >({
    method: "GET",
    url: getGetApiUserGenderUrl().toString(),
    ...requestConfig,
  });
  return res;
}
